"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    icon1: {
        en: "Truck",
        es: "Camion",
    },
    icon2: {
        en: "Sedan",
        es: "Turismo",
    },
    icon3: {
        en: "Trailer",
        es: "Cabezal",
    },
    icon4: {
        en: "Pickup",
        es: "Pickup",
    },
    icon5: {
        en: "Motorcycle",
        es: "Motocicleta",
    },
    icon6: {
        en: "Bus",
        es: "Bus",
    },
    icon7: {
        en: "Boat",
        es: "Lancha",
    },
    icon8: {
        en: "Panel",
        es: "Panelito",
    },
    icon9: {
        en: "Van",
        es: "Van",
    },
    icon10: {
        en: "Simple",
        es: "Simple",
    },
    icon11: {
        en: "Gas station",
        es: "Gasolinera",
    },
    icon12: {
        en: "Airport",
        es: "Aeropuerto",
    },
    icon13: {
        en: "Market",
        es: "Supermercado",
    },
    icon14: {
        en: "Hotel",
        es: "Hotel",
    },
    icon15: {
        en: "Coffee store",
        es: "Cafeteria",
    },
    icon16: {
        en: "Police",
        es: "Policía",
    },
    icon17: {
        en: "Restaurant",
        es: "Restaurante",
    },
    icon18: {
        en: "Sea port",
        es: "Puerto",
    },
    icon19: {
        en: "House",
        es: "Casa",
    },
    icon20: {
        en: "Bus Stop",
        es: "Parada",
    },
    icon21: {
        en: "Bar",
        es: "Bar",
    },
    icon22: {
        en: "Hospital",
        es: "Hospital",
    },
    icon23: {
        en: "Mixer",
        es: "Mezclador",
    },
    icon24: {
        en: "Person",
        es: "Persona",
    },
    icon25: {
        en: "Tank Truck",
        es: "Cisterna",
    },
    icon26: {
        en: "Dump Truck",
        es: "Volqueta",
    },
    icon27: {
        en: "Police Car",
        es: "Policía",
    },
    icon28: {
        en: "Ambulance",
        es: "Ambulancia",
    },
    icon29: {
        en: "GPS",
        es: "GPS",
    },
    icon30: {
        en: "Marker",
        es: "Marcador",
    },
    icon31: {
        en: "SUV",
        es: "Camioneta",
    },
    icon32: {
        en: "Tractor",
        es: "Tractor",
    },
    icon33: {
        en: "Flatbed Truck",
        es: "Tractor plano",
    },
    icon34: {
        en: "Stationary Tank",
        es: "Tanque Estacionario",
    },
    icon35: {
        en: "Industrial Machine",
        es: "Maquina Industrial",
    },
    icon37: {
        en: "Backhoe Loader",
        es: "Retroexcavadora",
    },
    icon38: {
        en: "Phone",
        es: "Teléfono",
    },
};
exports.default = translations;
